import { useEffect } from "react";
import api from "@/lib/api";

/**
 * SEO hook that:
 *  - sets static title/description immediately
 *  - then fetches /api/public/seo/{slug} (if slug provided) and overrides
 */
export default function useSEO({ title, description, slug }) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) setMeta("description", description);
    // Self-referencing canonical to the live domain (no hardcoded domain → becomes
    // https://pacleans.com/<path> in production). Overridable by an explicit canonical_url.
    setLinkRel("canonical", window.location.origin + window.location.pathname);
    setMeta("robots", "index,follow");

    if (slug) {
      api.get(`/public/seo/${slug}`).then((r) => {
        const d = r.data || {};
        if (d.seo_title) document.title = d.seo_title;
        if (d.meta_description) setMeta("description", d.meta_description);
        if (d.canonical_url) setLinkRel("canonical", d.canonical_url);
        setMeta("robots", d.index_page === false ? "noindex,nofollow" : "index,follow");
      }).catch(() => {});
    }
  }, [title, description, slug]);
}

function setMeta(name, content) {
  let tag = document.querySelector(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("name", name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

function setLinkRel(rel, href) {
  let link = document.querySelector(`link[rel="${rel}"]`);
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", rel);
    document.head.appendChild(link);
  }
  link.setAttribute("href", href);
}
